document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded, initializing appointment booking script...');
  
  // Create and append the dialog if it doesn't exist
  let dialog = document.querySelector('#appointment-dialog');
  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.id = 'appointment-dialog';
    dialog.style.cssText = 'width: 90%; max-width: 800px; height: 90vh; padding: 20px; border: none; border-radius: 8px;';
    
    // Add close button
    const closeButton = document.createElement('button');
    closeButton.textContent = '✕';
    closeButton.style.cssText = 'position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 24px; cursor: pointer; padding: 5px;';
    closeButton.addEventListener('click', () => dialog.close());
    
    dialog.appendChild(closeButton);
    document.body.appendChild(dialog);
  }
  
  // Initial attachment
  attachLinkListeners();
  
  // Watch for dynamically added elements (for AJAX-loaded content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        attachLinkListeners();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function attachLinkListeners() {
  // Select all links with data-match-id attribute
  const links = document.querySelectorAll('button[data-match-id]');
  if (links.length === 0) {
    console.log('No links with data-match-id found yet.');
    return;
  }
  
  links.forEach((link, index) => {
    // Skip if already has listener
    if (link.hasAttribute('data-listener-attached')) {
      return;
    }
    
    // Only attach if match ID is not empty or 0
    const matchId = link.dataset.matchId;
    if (!matchId || matchId === '0' || matchId === '') {
      console.log(`Skipping link #${index + 1} - no valid match ID`);
      return;
    }
    
    link.addEventListener('click', function(event) {
      event.preventDefault();
      console.log(`Link clicked for match_id: ${matchId}`);
      
      const dialog = document.querySelector('#appointment-dialog');
      if (!dialog) {
        console.error('Dialog not found');
        return;
      }
      
      // Check for country and construct appropriate URL
      const matchCountry = link.dataset.matchCountry;
      let iframeUrl;
      
      if (matchCountry === 'nl') {
        iframeUrl = `https://apollo2cs8.bnfoptics.com/OnlineBoekenOogwereld/agenda/frmBehandeling.aspx?D=cyu&FID=${matchId}`;
      } else {
        iframeUrl = `https://apollo2cs11.bnfoptics.com/OnlineBoekenOogwereld/agenda/frmBehandeling.aspx?D=oogwereld&FID=${matchId}`;
      }
      
      let iframe = dialog.querySelector('iframe');
      if (iframe) {
        iframe.src = iframeUrl;
      } else {
        iframe = document.createElement('iframe');
        iframe.src = iframeUrl;
        iframe.style.cssText = 'width: 100%; height: calc(100% - 40px); border: none; margin-top: 30px;';
        dialog.appendChild(iframe);
      }
      
      dialog.showModal();
    });
    
    // Mark as having listener
    link.setAttribute('data-listener-attached', 'true');
    console.log(`Event listener attached to link #${index + 1} with match_id="${matchId}"`);
  });
  
  const attachedLinks = document.querySelectorAll('a[data-listener-attached="true"]');
  console.log(`Total active listeners: ${attachedLinks.length}`);
}
document.getElementById('close-dialog').addEventListener('click', function() {
  document.getElementById('appointment-close-button').close();
});